<template>
  <step-header-component
    v-if="selectedStepHeader.header.length > 0"
    :headerText="selectedStepHeader.header"
    :subHeaderText="selectedStepHeader.subHeader">
    </step-header-component>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import StepHeaderComponent from './StepHeaderComponent.vue';
import StepHeader from '../../viewmodels/StepHeader';

@Component({
  components: {
  'step-header-component': StepHeaderComponent
  }
  })
export default class StepHeaderListComponent extends Vue {
  @Prop({ default: '' })
  public defaultTopic!: string;

  @Prop({ default: () => [] })
  public stepHeaders!: StepHeader[];

  public selectedStepHeader: StepHeader = new StepHeader();

  public queryStringTopic() : string | null {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('topic');
    } catch (error) {
      console.log('URLSearchParams not supported');
      return null;
    }
  }

  public findStepHeader(topic: string | null) : StepHeader | null {
    if (topic && topic.length > 0) {
      const match = this.stepHeaders.find((x) => x.topic.toLowerCase() === topic.toLowerCase());

      if (match) {
        return match;
      }
    }

    return null;
  }

  public setStepHeader() {
    if (this.stepHeaders && this.stepHeaders.length > 0) {
      const queryTopic = this.queryStringTopic();
      const queryStepHeader = this.findStepHeader(queryTopic);

      if (queryStepHeader) {
        this.selectedStepHeader = queryStepHeader;
        return;
      }

      if (this.defaultTopic && this.defaultTopic.length > 0) {
        const defaultStepHeader = this.findStepHeader(this.defaultTopic);

        if (defaultStepHeader) {
          this.selectedStepHeader = defaultStepHeader;
          return;
        }
      }

      // eslint-disable-next-line prefer-destructuring
      this.selectedStepHeader = this.stepHeaders[0];
    }
  }

  public mounted() {
    this.setStepHeader();
  }
}
</script>
